import withStyles from '@mui/styles/withStyles';
import React from "react";
import * as propTypes from "prop-types";
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import classNames from "classnames";
import { VideoButton } from "components/Chat/VideoButton";
import ExpandIcon from "common/assets/ExpandIcon.svg";
import RestoreIcon from "common/assets/RestoreIcon.svg";
import CircularIcon from "components/CircularIcon";
import { isEmpty, noop, truncate } from 'lodash';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from "@mui/material/IconButton";
import {color, font, type} from "common/tokens";

const styles = theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  // A quiet header on the surface, not a coloured bar: the conversation below
  // it is what should carry the colour.
  wrapper: {
    minHeight: 52,
    background: color.SURFACE,
    borderBottom: `1px solid ${color.DIVIDER}`,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '8px 20px',
    flexShrink: 0,
  },
  fullScreenWrapper: {
    minHeight: 52,
  },
  windowTitleText: {
    ...type.cardHeading,
    fontWeight: font.BOLD,
    color: color.TEXT,
  },
  titlePrefixText: {
    ...type.body,
    color: color.TEXT_MUTED,
  },
  subTitleText: {
    ...type.meta,
    fontWeight: font.REGULAR,
    color: color.TEXT_MUTED,
    marginTop: 2,
    cursor: 'pointer',
  },
  fullScreenSubTitle: {
    marginTop: 0,
    marginLeft: 0,
  },
  // Group names are content, not labels — shouting them was a hangover from the
  // old amber bar.
  windowTitleTextCaps: {},
  subTitleSingleLine: {
    whiteSpace: 'nowrap',
  },
});


const MessageWindowHeader = ({
  classes, windowTitle, subTitle, onBackPress, showExpandBtn, onExpandBtnPress = noop,
  showVideoBtn, isFullScreen, onSubTitleClick = noop, channel, showFullScreenButton,
  onFullScreenRequested, fullScreenVideo, titlePrefix, isBlackOutPeriodActive, showCloseBtn,
  closeBtnAction, showBackBtn, isAIChannel, isVideoRoomActiveForChatChannel
}) => {

  return (
    <div className={classNames(classes.wrapper, isFullScreen && classes.fullScreenWrapper)}>
      {showBackBtn && <div style={{display: 'flex', alignItems: 'center'}}><ArrowBackIcon style={{ color: color.TEXT_MUTED, cursor: 'pointer' }} onClick={onBackPress} /></div>}
      <div style={{ display: "flex", flexDirection: isFullScreen ? 'row' : 'column', alignItems: isFullScreen ? 'baseline' : 'start', gap: isFullScreen ? 8 : 0 }}>
        {!isEmpty(titlePrefix) && <div className={classes.titlePrefixText}>{titlePrefix}</div>}
        <div
          className={`${classes.windowTitleText} ${!isAIChannel && classes.windowTitleTextCaps}`}
        >
          {isFullScreen ? windowTitle : truncate(windowTitle, { length: 16 })}
        </div>
        { !isAIChannel &&
          <div className={classNames(classes.subTitleText, isFullScreen && classes.fullScreenSubTitle, classes.subTitleSingleLine)}
            onClick={onSubTitleClick}
          >{subTitle}</div>
        }
      </div>
      <div style={{ display: 'flex', marginLeft: 'auto', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', gap: 4 }}>
        {showVideoBtn && !isAIChannel && <VideoButton channel={channel}
          isBlackedOut={isBlackOutPeriodActive}
          isVideoRoomActiveForChatChannel={isVideoRoomActiveForChatChannel}
        />}
        {showFullScreenButton &&
          <CircularIcon onClick={onFullScreenRequested}>
            <img src={fullScreenVideo ? RestoreIcon : ExpandIcon} alt={""} />
          </CircularIcon>}
        {(showExpandBtn && !isFullScreen) &&
          <ExpandMoreIcon style={{ cursor: 'pointer' }} onClick={onExpandBtnPress} />
        }
        {
          showCloseBtn &&
          <IconButton edge={'end'} onClick={closeBtnAction} size="large">
            <CloseIcon style={{ color: '#000' }} />
          </IconButton>
        }
      </div>
    </div>
  );
};

export default withStyles(styles)(MessageWindowHeader);


MessageWindowHeader.propTypes = {
  windowTitle: propTypes.string.isRequired,
  subTitle: propTypes.string,
  showExpandBtn: propTypes.bool,
  onExpandBtnPress: propTypes.func,
  onBackPress: propTypes.func,
  isFullScreen: propTypes.bool,
  isBlackOutPeriodActive: propTypes.bool,
  showCloseBtn: propTypes.bool,
  showBackBtn: propTypes.bool,
  closeBtnAction: propTypes.func,
  isVideoRoomActiveForChatChannel: propTypes.bool,
};

MessageWindowHeader.defaultProps = {
  showVideoBtn: true,
  showExpandBtn: true,
  isFullScreen: false,
  showBackBtn: false
};
